import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams } from 'ag-grid-community';
import { FormControl, Validators } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

interface CustomFilterParams extends IFilterParams {
  singleMenu?: boolean
  sortState?: () => {}
  onSort?: (param1: 'asc' | 'desc' | null, param2: string) => void;
  getSortDirection?: (colId: string) => 'asc' | 'desc' | null;

}

interface TabOptionsSubMenu {
  label: string;
  action: string;
  icon: string;
  active: boolean
}

interface TabOptions {
  label: string;
  active: boolean;
  icon: string;
  type: string;
}


@Component({
  selector: 'app-custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomMultiSelectFilterComponent implements IFilterAngularComp, AfterViewInit, AfterViewChecked {

  @ViewChild('container') containerRef!: ElementRef;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;
  @ViewChildren('spanChild') spanChildren!: QueryList<ElementRef<HTMLElement>>;


  params!: CustomFilterParams;
  selectedValues: Set<any> = new Set();
  uniqueValues: any[] = [];
  originalUniqueValues: any[] = []
  searchTerm!: FormControl
  labelWidth!: any
  allSelected = false;
  isSingleMenu = false
  currentSort: 'asc' | 'desc' | null = null;
  selectedTabType!: string;


  tabOptions: TabOptions[] = [
    {label: 'Fixar colunas', icon: 'push_pin', active: false, type: 'pin'},
    {label: 'Filtrar colunas', icon: 'filter_alt', active: false, type: 'filter'},
    {label: 'Ordenar colunas', icon: 'swap_vert', active: false, type: 'sort'}
  ]

  fixOptions: TabOptionsSubMenu[] = [
    { label: 'Não fixar', active: true, action:'dontFix', icon: 'view_column' },
    { label: 'Fixar à esquerda', active: false, action:'fixLeft', icon: 'first_page'  },
    { label: 'Fixar à direita', active: false, action:'fixRight', icon: 'last_page'  }
  ];

  sortOptions: TabOptionsSubMenu[] = [
    { label: 'Ordernar ascendente', active: false, action: 'sortAsc', icon: 'arrow_drop_up' },
    { label: 'Ordernar descendente', active: false, action: 'sortDesc', icon: 'arrow_drop_down' }
  ]

  constructor(private cdr: ChangeDetectorRef) {
    this.searchTerm = new FormControl(null, Validators.required);
    this.searchTerm.valueChanges.subscribe( v => this.filterOptions(v))
  }

  isTextTruncated(span: HTMLElement, container: HTMLElement): boolean {
    return span.clientWidth > container.clientWidth;
  }

  filterOptions(value) {
    this.uniqueValues = this.originalUniqueValues;
    this.uniqueValues = this.uniqueValues.filter( item => {
      if(!!item.viewValue)
      return item.viewValue.toString().toLowerCase().includes(value.toLowerCase())
    });
    if(this.uniqueValues.length > 0) this.checkIfAllSelected();
  }

  agInit(params: CustomFilterParams): void {
    this.isActionEnabled(params)
    this.isSingleMenu = params.singleMenu || false
    this.params = params;
    this.initialCol();
    this.extractUniqueValues();
    if(this.isSingleMenu){
      this.updateSortState();
    }
  }

  initialCol() {
    const sortState = this.params.sortState?.();
    const colId = this.params.column.getColId();
    if (sortState?.[colId]) {
      const foundOption = this.sortOptions.find(
        option => option.action === sortState[colId]
      );
      if (foundOption) {
        foundOption.active = true;
      }
    }
  }


  isActionEnabled(params: CustomFilterParams){
    const mapRules = {
      'sort': params.column.getColDef().sortable,
      'pin': !params.column.getColDef().lockPinned ? true : false,
      'filter': params.column.getColDef().filter 
    }
    this.tabOptions =  this.tabOptions.filter(item => mapRules[item.type])
    this.setTab(this.tabOptions[0].type)
  }


  setTab(type: string) {
    this.selectedTabType = type;
    setTimeout(() => {
        if (
          this.selectedTabType === 'filter' &&
          this.containerRef &&
          !this.uniqueValues.some((i) => i.isTruncated)
        ) {
          this.checkTruncation();
        }
    })
  }

  ngAfterViewInit() {
    if(!this.isSingleMenu){
        setTimeout(() => {
         this.checkTruncation();
        })
    }

    if (this.containerRef && this.containerRef.nativeElement && !this.isSingleMenu) {
      this.labelWidth = this.containerRef.nativeElement.clientWidth - 24;
    }

    this.cdr.detectChanges();
  }

  checkTruncation() {
    const spanEls = this.spanChildren.toArray();
    this.uniqueValues = this.uniqueValues.map((item, index) => {
      const span = spanEls[index]?.nativeElement;
      this.labelWidth = this.containerRef.nativeElement.clientWidth;
      const isTruncated =  span?.clientWidth > this.containerRef.nativeElement.clientWidth;
      return {
        ...item,
        isTruncated
      };
    });
    this.cdr.detectChanges();
  }

  trackValue(index, item){
    return item.value
  }

  ngAfterViewChecked(): void {
    if (this.virtualScroll) {
      this.virtualScroll.checkViewportSize(); 
    }
  }

  extractUniqueValues(firstCall = true) {
    const field = this.params.colDef.field as string;
    if (!field) return;

    const allValues: any[] = [];
    this.params.api.forEachNode(node => {
      if (!node.data?.isDetailRow && node.data[field] !== '' && node.data[field] !== undefined && node.data[field] !== null) {
        allValues.push(node.data[field]);
        if(firstCall){
          this.selectedValues.add(node.data[field])
        }
      }
    });

    if(firstCall){
      this.checkIfAllSelected()
    }

    let unique = Array.from(new Set(allValues)).sort();

    unique = unique.map(i => ({value: i, viewValue: this.formatValue(i)}))
    
    this.uniqueValues = unique
    this.originalUniqueValues = [...unique]
  }

  onSelectionChange(value: any, event: any) {
    if (value === 'selectAll') {
      this.selectedValues = event.target.checked
        ? new Set(this.uniqueValues.map(item => item.value))
        : new Set();                
    } else {
      if (event.target.checked) {
        this.selectedValues.add(value);
      } else {
        this.selectedValues.delete(value);
      }
    }
    this.checkIfAllSelected();
  
    this.params.filterChangedCallback();
  }


  checkIfAllSelected() {
    this.allSelected = this.uniqueValues.every(item => this.selectedValues.has(item.value));
    if (this.allSelected ) {
      this.selectedValues.add('selectAll');
    } else {
      this.selectedValues.delete('selectAll');
    }
  }
  
  isChecked(value: any): boolean {
    return this.selectedValues.has(value);
  }

  doesFilterPass(params: any): boolean {
    if (params.data?.isDetailRow) {
      return true; 
    }
    if (this.selectedValues.size === 0) return true;

    const field = this.params.colDef.field as string;
    if (!field) return false;

    if (params.data.isGroup) {
      const groupId = params.data.id;
  
      let hasVisibleChild = false;

        this.params.api.forEachNode((node) => {
        if (
          node.data &&
          node.data.groupId === groupId &&
          this.selectedValues.has(node.data[field])
        ) {
          hasVisibleChild = true;
        }
      });
  
      return hasVisibleChild;
    }

    return this.selectedValues.has(params.data[field]);
  }

  isFilterActive(): boolean {
    return this.selectedValues.size > 0;
  }

  getModel() {
    return { selectedValues: Array.from(this.selectedValues) };
  }

  setModel(model: any) {
    this.selectedValues = new Set(model ? model.selectedValues : []);
  } 
  
  clearSearch(clear: boolean){
    if(clear) this.searchTerm.reset()
    this.filterOptions('')
  }


  formatValue(value: unknown){
    const cellType = this.params.colDef.cellDataType
    let formatter
    if(!!cellType && typeof cellType === 'string' && this.params.context['dataTypeDefinitions'][cellType]){
      formatter = this.params.context['dataTypeDefinitions'][cellType]['valueFormatter']
    }
    if (formatter && typeof formatter === 'function') {
      try {
        value = formatter({...this.params, value});
      } catch (err) {
        console.warn(`Erro ao aplicar formatter para tipo '${cellType}' no campo '${this.params.colDef.field}'`, err);
      }
    }
    return value  

  }

  refreshOptions(oldValue: any, newValue: any) {
    const currentValues: any[] = [];
    this.params.api.forEachNodeAfterFilterAndSort(node => {
      if (!node.data.isGroup) {
        currentValues.push(node.data);
      }
    });

    const wasSelected = this.selectedValues.has(oldValue);
    if (wasSelected) {
      this.selectedValues.delete(oldValue);
      this.selectedValues.add(newValue);
    }
  
    this.uniqueValues = this.updateUniqueList(this.uniqueValues, oldValue, newValue, currentValues);
    this.originalUniqueValues = this.updateUniqueList(this.originalUniqueValues, oldValue, newValue, currentValues);
  
    const stillExists = currentValues.some(v => v[this.params.column.getColId()] === oldValue);
    if (stillExists) {
      this.selectedValues.add(oldValue);
    }
  
    this.checkIfAllSelected();
    this.cdr.detectChanges();
  }

  private updateUniqueList(
    list: { value: any; viewValue: string }[],
    oldValue: any,
    newValue: any,
    currentValues: any[]
  ) {
    const formattedNewValue = this.formatValue(newValue);

    const updatedList = list.map(item =>
      item.value === oldValue ? { value: newValue, viewValue: formattedNewValue } : item
    );

    const oldValueStillExists = currentValues.some(v =>
      Object.values(v).includes(oldValue)
    );

    if (oldValueStillExists) {
      const formattedOldValue = this.formatValue(oldValue);
      const foundIndex = updatedList.findIndex(i => i.value === newValue);
      const alreadyHasOld = updatedList.some(i => i.value === oldValue);

      if (foundIndex !== -1 && !alreadyHasOld) {
        updatedList.splice(foundIndex + 1, 0, { value: oldValue, viewValue: formattedOldValue });
      }
    }

    return updatedList;
  }


  handleOption(option: TabOptionsSubMenu, index: number, optionsArray: TabOptionsSubMenu[]): void {

    const colId = this.params.column.getColId()

    switch (option.action) {
      case 'dontFix':
        this.params.columnApi.setColumnPinned(colId, false)
        break;

      case 'fixLeft':
        this.params.columnApi.setColumnPinned(colId, 'left')
        break;

      case 'fixRight':
        this.params.columnApi.setColumnPinned(colId, 'right')
        break;

      case 'sortAsc':
        this.handleSort('asc')

        break;

      case 'sortDesc':
        this.handleSort('desc')

        break;

      default:
        console.warn('Ação desconhecida:', option.action);
        break;
    }

    optionsArray.forEach((item, idx) => {
      if(idx === index){
        item.active = true
        return
      }
      item.active = false
    })

  }


   handleSort(direction): void {
    const newSort =
      this.currentSort === 'asc'
        ? 'desc'
        : this.currentSort === 'desc'
        ? null
        : 'asc';
    const colId = this.params.column.getColId();

    const field = this.params.columnApi.getColumn(colId)?.getColDef().field || ''
    this.currentSort = direction;
    // this.updateSortIcon();

    if (this.params.onSort) {
      this.params.onSort(direction, field);
    }

    this.cdr.detectChanges();
  }

  updateSortState(): void {
    const colId = this.params.column.getColId();

    if (this.params.getSortDirection) {
      this.currentSort = this.params.getSortDirection(colId);
    } else {
      this.currentSort = null;
    }

  }


}
